import BasketBoard from "../components/BasketBoard";
import { fmtSol, fmtTime, shortMint } from "../lib/data";

export default function BasketPage({ data }) {
  const basket = data?.basket;
  const totals = data?.payoutTotals;
  const allMints = totals?.mints || [];

  return (
    <section className="app-section" style={{ paddingTop: "2.5rem" }}>
      <div className="shell">
        <p className="section-kicker">
          <i className="brand-diamond" aria-hidden /> Basket
        </p>
        <div className="section-intro">
          <h2 className="section-title">What the fund is buying</h2>
          <p className="section-lead left">
            Updated {fmtTime(basket?.createdAt)}. Next refresh in{" "}
            {basket?.minutesUntilRefresh ?? "—"} minutes.
            {totals?.totalSolAll != null && totals.totalSolAll > 0
              ? ` All-time buys: ${fmtSol(totals.totalSolAll)} SOL.`
              : ""}{" "}
            Holders can pin one seat via the{" "}
            <a href="/community">community vote</a>.
          </p>
        </div>
        <BasketBoard basket={basket} payoutTotals={totals} />

        {allMints.length > 0 && (
          <div style={{ marginTop: "2.5rem" }}>
            <h3 className="section-title" style={{ fontSize: "1.35rem" }}>
              Cumulative payouts
            </h3>
            <p className="section-lead left" style={{ marginBottom: "1rem" }}>
              Total SOL spent buying each name across every spend cycle (including
              names that have since rotated off the board).
            </p>
            <div className="history-grid">
              {allMints.map((row) => (
                <article className="history-card cycle-card" key={row.mint}>
                  <div className="history-card__top">
                    <strong>${row.symbol}</strong>
                    <span>{row.cycles} cycles</span>
                  </div>
                  <div className="cycle-meta">
                    <span>
                      Bought with <b>{fmtSol(row.totalSol)} SOL</b>
                    </span>
                    <span>
                      Deliveries <b>{row.delivered ?? "—"}</b>
                    </span>
                    <span>
                      Last {row.lastAt ? fmtTime(row.lastAt) : "—"}
                    </span>
                  </div>
                  <p className="portfolio-footnote" style={{ marginTop: "0.75rem" }}>
                    <a
                      href={`https://www.stonkfun.xyz/token/${row.mint}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {shortMint(row.mint)}
                    </a>
                  </p>
                </article>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
